import gql from 'graphql-tag'

export const GET_PRODUCT_SUBCATEGORY_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
  ) {
    getProductSubcategoryPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        id
        titleEn
        titleRu
        titleKg
        category {
          id
          titleEn
          titleRu
          titleKg
        }
      }
    }
  }
`

export const GET_PRODUCT_SUBCATEGORY_WITH_DATA_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getProductSubcategory (
      data: {
        id: $id
      }
    ) {
      id
      titleEn
      titleRu
      titleKg
      categoryId
    }
    getAllProductCategories {
      id
      titleEn
      titleRu
      titleKg
    }
  }
`
